import { getProjectName } from 'lib/get-project-name'
import React, { FC } from 'react'
import styled from 'styled-components'
import { Icon } from 'ui/icon'
import { EcomIconsId } from 'ui/icon/types'

export type Props = {
  specifications: Array<SpecificationProps>
}

export type SpecificationProps = {
  text: string
  icon?: EcomIconsId
}

export const Specifications: FC<Props> = ({ specifications = [] }) => {
  return (
    <Wrapper>
      {specifications.map((spec) => (
        <Specification key={spec.text} {...spec} />
      ))}
    </Wrapper>
  )
}

const Specification: FC<SpecificationProps> = ({ text, icon }) => {
  return (
    <SpecWrapper>
      <Inner>
        {icon && <Icon name={icon} size={0.75} />}
        <Text>{text}</Text>
      </Inner>
    </SpecWrapper>
  )
}

const Wrapper = styled.div`
  color: ${({ theme }) => theme.palette.grey[900]};
  color: ${({ theme }) => getProjectName() === 'mercedes-benz' && theme.palette.white};
  line-height: 1.5;
`

const SpecWrapper = styled.div`
  position: relative;
  vertical-align: baseline;
  line-height: 1;

  &:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacing[2]};
  }
`

const Inner = styled.div`
  display: flex;
  align-items: center;
  line-height: 1.5;
  color: ${({ theme }) => theme.palette.grey[500]};
  color: ${({ theme }) => getProjectName() === 'mercedes-benz' && 'inherit'};
`

const Text = styled.div`
  padding-left: 0.4em;
  ${({ theme }) =>
    getProjectName() === `avito` ? `font-weight: 400; font-size: 14px; line-height: 16px;` : theme.textStyles.p3};
  color: ${({ theme }) => theme.palette.grey[900]};
  color: ${({ theme }) => getProjectName() === 'mercedes-benz' && 'inherit'};
`
